import { MenuItem } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import VyButton from '../../../../common/VyButton';
import VyModal from '../../../../common/VyModal';
import VySelect from '../../../../common/VySelect';
import { CTAButtonComponentInterface } from '../../../../../interfaces/pagebuilder';
import { useTranslation } from 'next-i18next';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import { useState } from 'react';
import { FieldValuePair } from '../../../../../interfaces/interfaces';

export const DataUpdateModal = ({
  component,
  profileField,
  onChange,
  onClose,
}: {
  component: CTAButtonComponentInterface;
  profileField?: FieldValuePair | null;
  onChange: (e: any) => void;
  onClose: () => void;
}) => {
  const guestmanagementFields = useSelector((state) => state.common.registrationFields);
  const selectFields = guestmanagementFields.filter(
    (field) => (field.fieldType === 'text' && field.textValueOptions.length > 0) || field.fieldType === 'language'
  );

  const { control, handleSubmit } = useForm();
  const { t } = useTranslation();

  const [currentField, setCurrentField] = useState(profileField);

  async function submitDataUpdateField(props: FieldValuePair) {
    const fields = [...component.dataUpdateFields];
    const index = fields.findIndex((f) => f.field === props.field);
    if (index >= 0) {
      fields.splice(index, 1);
    }
    fields.push(props);

    onChange({
      ...component,
      dataUpdateFields: fields,
    });
    onClose();
  }

  function fieldIsUsed(id: string) {
    return component.dataUpdateFields.find((field) => field.field === id);
  }

  return (
    <VyModal open={currentField !== undefined} onClose={onClose}>
      {(onClose) => (
        <form onSubmit={handleSubmit(submitDataUpdateField)}>
          <p>{t('pagebuilder:cta.data-update-field')}</p>
          <Controller
            control={control}
            name={'field'}
            defaultValue={currentField?.field}
            render={({ field: { onChange, value } }) => (
              <VySelect
                defaultValue={currentField?.field}
                fullWidth
                required
                disabled={profileField?.value !== undefined}
                onChange={(e) => {
                  onChange(e);
                  //@ts-ignore
                  setCurrentField({ field: e.target.value });
                }}>
                {selectFields
                  .filter((f) => !fieldIsUsed(f._id!) || currentField?.field === f._id)
                  .map((field) => (
                    <MenuItem key={field._id} value={field._id}>
                      {field.label}
                    </MenuItem>
                  ))}
              </VySelect>
            )}
          />
          <p className="mt-4">{t('pagebuilder:cta.data-update-value')}</p>
          <Controller
            control={control}
            name={'value'}
            defaultValue={currentField?.value}
            render={({ field: { onChange, value } }) => (
              <VySelect defaultValue={currentField?.value} onChange={onChange} fullWidth required>
                {selectFields
                  .find((f) => f._id === currentField?.field)
                  ?.textValueOptions.map((option) => (
                    <MenuItem key={option.content} value={option.content}>
                      {option.content}
                    </MenuItem>
                  ))}
                {selectFields?.find((f) => f._id === currentField?.field)?.fieldType === 'language' &&
                  ['de', 'en', 'fr'].map((language) => (
                    <MenuItem key={language} value={language}>
                      {t(`common:languages.${language}`)}
                    </MenuItem>
                  ))}
              </VySelect>
            )}
          />
          <div className="flex justify-between space-x-4 mt-4">
            <VyButton type="submit">{t('account:submit')}</VyButton>
            <VyButton ghost onClick={onClose}>
              {t('account:cancel')}
            </VyButton>
          </div>
        </form>
      )}
    </VyModal>
  );
};
